import {ObjUtil} from 'yougile-util'
import {DataObjectId, storage2FaKeys, TwoFactorStep} from 'yougile-model'
import {Storage} from '@client/storage'

interface TwoFactorStorageData {
  twoFactorStep?: TwoFactorStep
  loginFormEmail?: string
  loginFormPassword?: string
  userId?: DataObjectId
  authKey?: string
  retryTimestamp?: number
  twoFactorCodeSentTo?: string
  isPhoneSetByUser?: boolean
}

export class LoginHelper {
  static get2FaDataFromStorage(): TwoFactorStorageData {
    const storage2FaStep = Storage.getItem(storage2FaKeys.step) as
      | TwoFactorStep
      | undefined
    const storage2FaLogin = Storage.getItem(storage2FaKeys.login)
    const storage2FAPass = Storage.getItem(storage2FaKeys.pass)
    const storage2FaUserId = Storage.getItem(storage2FaKeys.userId) as
      | DataObjectId
      | undefined
    const storageAuthKey = Storage.getItem(storage2FaKeys.authKey)
    const retryTimestamp = Storage.getItem(storage2FaKeys.retryTimestamp)
    const twoFactorCodeSentTo = Storage.getItem(storage2FaKeys.codeSentTo)
    const isPhoneSetByUser = Storage.getItem(storage2FaKeys.isPhoneSetByUser)

    const result: TwoFactorStorageData = {
      twoFactorStep: storage2FaStep,
      loginFormEmail: storage2FaLogin,
      loginFormPassword: storage2FAPass,
      userId: storage2FaUserId,
      authKey: storageAuthKey,
      retryTimestamp: Number(retryTimestamp),
      twoFactorCodeSentTo,
      isPhoneSetByUser: isPhoneSetByUser === '1'
    }

    return ObjUtil.removeEmptyValues(result)
  }

  static set2FaDataToStorage({
    twoFactorStep,
    loginFormEmail,
    loginFormPassword,
    userId,
    authKey,
    retryTimestamp,
    twoFactorCodeSentTo,
    isPhoneSetByUser
  }: TwoFactorStorageData): void {
    if (twoFactorStep) {
      Storage.setItem(storage2FaKeys.step, twoFactorStep)
    }
    if (loginFormEmail) {
      Storage.setItem(storage2FaKeys.login, loginFormEmail)
    }
    if (loginFormPassword) {
      Storage.setItem(storage2FaKeys.pass, loginFormPassword)
    }
    if (userId) {
      Storage.setItem(storage2FaKeys.userId, userId)
    }
    if (authKey) {
      Storage.setItem(storage2FaKeys.authKey, authKey)
    }
    if (retryTimestamp) {
      Storage.setItem(storage2FaKeys.retryTimestamp, String(retryTimestamp))
    }
    if (twoFactorCodeSentTo) {
      Storage.setItem(storage2FaKeys.codeSentTo, twoFactorCodeSentTo)
    }
    if (isPhoneSetByUser !== undefined) {
      Storage.setItem(
        storage2FaKeys.isPhoneSetByUser,
        isPhoneSetByUser ? '1' : '0'
      )
    }
  }

  static clear2faFromStorage(): void {
    Storage.removeItem(storage2FaKeys.step)
    Storage.removeItem(storage2FaKeys.login)
    Storage.removeItem(storage2FaKeys.pass)
    Storage.removeItem(storage2FaKeys.userId)
    Storage.removeItem(storage2FaKeys.authKey)
    Storage.removeItem(storage2FaKeys.retryTimestamp)
    Storage.removeItem(storage2FaKeys.codeSentTo)
    Storage.removeItem(storage2FaKeys.isPhoneSetByUser)
  }
}
